<template>
  <Teleport to="body">
    <div v-if="visible" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-4 z-[9998] animate-fadeIn">
      <div class="bg-white dark:bg-gray-800 rounded-[2rem] shadow-2xl w-full max-w-lg overflow-hidden animate-zoomIn border border-gray-100 dark:border-gray-700">

        <!-- Header -->
        <div class="px-6 py-5 bg-gradient-to-r from-teal-600 to-emerald-600 flex items-center gap-4 text-white">
          <div class="p-3 bg-white/20 rounded-2xl backdrop-blur-md animate-pulse">
            <Icon icon="mdi:cellphone-check" class="text-3xl" />
          </div>
          <div class="flex-1">
            <h3 class="text-lg font-black tracking-tight">¡Hoy es Miércoles!</h3>
            <p class="text-white/80 font-bold text-[10px] uppercase tracking-widest">
              Liquidación Semanal Cashea
            </p>
          </div>
          <button
            @click="cerrar"
            class="p-1.5 bg-white/10 hover:bg-white/20 rounded-xl transition-all"
          >
            <Icon icon="mdi:close" class="text-xl" />
          </button>
        </div>

        <!-- Body -->
        <div class="p-6 space-y-4">

          <!-- Loading -->
          <div v-if="cargando" class="flex flex-col items-center justify-center py-8">
            <Icon icon="mdi:loading" class="animate-spin text-4xl text-teal-500 mb-3" />
            <p class="text-sm text-gray-500 font-bold">Consultando pago semanal...</p>
          </div>

          <!-- Contenido -->
          <template v-else-if="pagoSemanal">
            <!-- Neto a recibir destacado -->
            <div class="bg-gradient-to-br from-teal-50 to-emerald-50 dark:from-teal-900/20 dark:to-emerald-900/20 rounded-2xl p-5 border border-teal-100 dark:border-teal-800/40 text-center">
              <p class="text-[10px] font-black text-teal-600 dark:text-teal-400 uppercase tracking-widest mb-1">
                Neto a Recibir
              </p>
              <p class="text-4xl font-black text-teal-600 dark:text-teal-400 leading-none">
                {{ formatCurrency(pagoSemanal.montoNetoRecibir) }}
              </p>
              <p class="text-[10px] font-bold text-gray-500 mt-2">
                {{ pagoSemanal.cantidadCreditos }} créditos · {{ pagoSemanal.cantidadCuotas }} cuotas
              </p>
            </div>

            <!-- Desglose -->
            <div class="grid grid-cols-3 gap-2">
              <div class="bg-gray-50 dark:bg-gray-900/50 rounded-xl p-3 border border-gray-100 dark:border-gray-700">
                <p class="text-[8px] font-black text-gray-400 uppercase tracking-widest mb-1">Bruto</p>
                <p class="text-sm font-black text-gray-700 dark:text-gray-200">
                  {{ formatCurrency(pagoSemanal.totalBruto) }}
                </p>
              </div>
              <div class="bg-gray-50 dark:bg-gray-900/50 rounded-xl p-3 border border-gray-100 dark:border-gray-700">
                <p class="text-[8px] font-black text-gray-400 uppercase tracking-widest mb-1">Comisión</p>
                <p class="text-sm font-black text-rose-500">
                  -{{ formatCurrency(pagoSemanal.descuentoComision) }}
                </p>
                <p class="text-[8px] font-bold text-gray-400">{{ pagoSemanal.porcentajeComision }}%</p>
              </div>
              <div class="bg-gray-50 dark:bg-gray-900/50 rounded-xl p-3 border border-gray-100 dark:border-gray-700">
                <p class="text-[8px] font-black text-gray-400 uppercase tracking-widest mb-1">Neto</p>
                <p class="text-sm font-black text-teal-600">
                  {{ formatCurrency(pagoSemanal.montoNetoRecibir) }}
                </p>
              </div>
            </div>

            <!-- Info adicional -->
            <div class="bg-indigo-50 dark:bg-indigo-900/20 rounded-xl p-3 border border-indigo-100 dark:border-indigo-800/40 flex items-start gap-3">
              <Icon icon="mdi:information-outline" class="text-indigo-500 text-lg shrink-0 mt-0.5" />
              <div class="text-[11px] text-indigo-800 dark:text-indigo-300 font-medium leading-snug">
                <p><b>Fecha de pago:</b> {{ pagoSemanal.fechaPagoFormateada }} ({{ pagoSemanal.diaSemana }})</p>
                <p><b>App:</b> {{ pagoSemanal.nombreApp }}</p>
              </div>
            </div>
          </template>

          <!-- Sin datos -->
          <div v-else class="text-center py-6">
            <Icon icon="mdi:calendar-check-outline" class="text-5xl text-gray-300 mx-auto mb-3" />
            <p class="text-sm font-bold text-gray-500">
              No hay créditos Cashea pendientes para esta semana.
            </p>
            <p class="text-xs text-gray-400 mt-1">Todo está al día.</p>
          </div>

        </div>

        <!-- Footer -->
        <div class="px-6 pb-6 flex flex-col sm:flex-row gap-3">
          <button
            @click="cerrar"
            class="w-full sm:flex-1 py-3 border-2 border-gray-100 dark:border-gray-700 text-gray-500 dark:text-gray-400 rounded-2xl font-black text-[10px] uppercase tracking-widest hover:bg-gray-50 dark:hover:bg-gray-700 transition-all"
          >
            Recordar más tarde
          </button>
          <button
            @click="irALiquidacion"
            :disabled="!pagoSemanal || pagoSemanal.cantidadCreditos === 0"
            class="w-full sm:flex-1 py-3 bg-gradient-to-r from-teal-600 to-emerald-600 hover:from-teal-700 hover:to-emerald-700 disabled:opacity-50 text-white rounded-2xl font-black text-[10px] uppercase tracking-widest transition-all shadow-xl shadow-teal-500/30 flex items-center justify-center gap-2"
          >
            <Icon icon="mdi:check-all" class="text-base" />
            Ver Liquidación
          </button>
        </div>

      </div>
    </div>
  </Teleport>
</template>

<script>
import { Icon } from '@iconify/vue';
import { obtenerPagoSemanal, obtenerProximoMiercoles, CODIGO_CASHEA } from '@/api/creditoApp.js';

const STORAGE_KEY = 'casheaAvisoSemanalDismissed';

export default {
  name: 'AvisoCasheaSemanal',
  components: { Icon },
  data() {
    return {
      visible: false,
      cargando: false,
      pagoSemanal: null
    };
  },
  async mounted() {
    // 1. Verificar rol
    if (!this.esAdmin) {
      return;
    }

    // 2. Verificar que hoy sea miércoles
    if (new Date().getDay() !== 3) {
      return;
    }

    // 3. Verificar que no se haya descartado hoy
    if (this.yaDescartadoHoy()) {
      return;
    }

    // 4. Mostrar y cargar datos
    this.visible = true;
    await this.cargarPagoSemanal();
  },
  computed: {
    esAdmin() {
      const rol = (localStorage.getItem('rol') || '').toLowerCase();
      return (
        rol.includes('superadmin') ||
        rol.includes('super admin') ||
        rol.includes('administrador') ||
        rol === 'admin'
      );
    }
  },
  methods: {
    /**
     * Verifica si ya se descartó hoy
     */
    yaDescartadoHoy() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        const data = JSON.parse(raw);
        const hoy = new Date().toISOString().split('T')[0];
        return data.fecha === hoy;
      } catch {
        return false;
      }
    },

    /**
     * Marca como descartado hoy
     */
    marcarDescartado() {
      try {
        const hoy = new Date().toISOString().split('T')[0];
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ fecha: hoy }));
      } catch (e) {
        console.warn('No se pudo guardar el descarte:', e);
      }
    },

    /**
     * Carga el pago semanal del backend
     */
    async cargarPagoSemanal() {
      this.cargando = true;
      try {
        const miercoles = obtenerProximoMiercoles();
        const res = await obtenerPagoSemanal(CODIGO_CASHEA, miercoles);

        if (res.success) {
          this.pagoSemanal = res.data;
        } else {
          console.warn('No se pudo cargar el pago semanal:', res.error);
          this.pagoSemanal = null;
        }
      } catch (e) {
        console.error('Error cargando pago semanal:', e);
        this.pagoSemanal = null;
      } finally {
        this.cargando = false;
      }
    },

    /**
     * Cierra el modal y lo marca como descartado por hoy
     */
    cerrar() {
      this.visible = false;
      this.marcarDescartado();
    },

    /**
     * Redirige a GestionCreditos en la pestaña Cashea
     */
    irALiquidacion() {
      this.marcarDescartado();
      this.visible = false;
      this.$router.push('/gestion-creditos?tab=cashea');
    },

    /**
     * Formatear moneda USD
     */
    formatCurrency(value) {
      if (value === null || value === undefined || isNaN(value)) return '$0.00';
      const num = typeof value === 'string' ? parseFloat(value) : value;
      return new Intl.NumberFormat('es-VE', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num);
    }
  }
};
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
.animate-fadeIn { animation: fadeIn 0.3s ease-out forwards; }
.animate-zoomIn { animation: zoomIn 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) forwards; }
</style>